import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

// 签到相关API
export const signApi = {
  /**
   * 签到
   * @returns Promise<ApiResponse>
   */
  sign: (game_id: number): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SIGN,
      API_CONFIG.ACTIONS.SIGN,
      { game_id }
    );
    return get<ApiResponse>(url);
  },
};
